import { Component, inject, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthenticationService } from '../../core/http/authentication.service';

@Component({
  template: '',
  standalone: true,
})
export class LogoutComponent implements OnInit {
  private _authService = inject(AuthenticationService);
  private _router = inject(Router);

  ngOnInit() {
    this._authService.logout();
    this._authService.removeSessionData();
    this._router.navigate(['login']);
  }
}
